module.exports = __webpack_public_path__ + "static/media/2019_IMG_4120.952b8094.jpg";